module.exports = __webpack_public_path__ + "img/2.99b95450.jpg";